import React from 'react';
import { Box } from '@hover/blueprint';
import SlideMobile from './SlideMobile';
import SlideDesktopAndTablet from './SlideDesktopAndTablet';

const TrustedByNamesSlide: React.FC = () => (
  <>
    <Box d={{ base: 'none', tablet: 'flex' }} w="100%">
      <SlideDesktopAndTablet />
    </Box>
    <SlideMobile />
  </>
);

export default TrustedByNamesSlide;
